import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import Providers from "./components/Providers";
import { Loader } from "./components/common";
import { KeycloakProvider } from "./components/KeycloakProvider";
import { initializeI18n } from "./i18n";

import "./styles/globals.css";

initializeI18n().then(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <Suspense fallback={<Loader />}>
        <Providers>
          <KeycloakProvider>
            <BrowserRouter basename="/portal">
              <Toaster
                position="top-center"
                reverseOrder={false}
                toastOptions={{
                  success: {
                    style: {
                      backgroundColor: "#3cbb02",
                      color: "#fff",
                    },
                  },
                  error: {
                    style: {
                      backgroundColor: "#ee4444",
                      color: "#fff",
                    },
                  },
                }}
              />
              <App />
            </BrowserRouter>
          </KeycloakProvider>
        </Providers>
      </Suspense>
    </React.StrictMode >
  );
});
